import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "no-reflections",
  templateUrl: "./no-reflections.component.html",
  styleUrls: ["./no-reflections.component.less"],
})
export class NoReflectionsComponent {
  @Input()
  public includeCTAButton = true;

  @Output()
  public onCTAClick: EventEmitter<void> = new EventEmitter();
}
